<cap-content-header>
  <cap-title>
    {{ "GefundeneRechte" | translate }}
  </cap-title>
  <cap-title-functionbar>
    @if (rechteIds.length >= 2) {
      <button
        (click)="getZip()"
        [disabled]="gbPrintService.zipInProgressMap.get(0)"
        class="btn btn-outline-primary btn-sm me-2"
        type="button">
        @if (gbPrintService.zipInProgressMap.get(0)) {
          <span class="spinner-border spinner-border-sm text-primary me-1"></span>
        }
        {{ "Auszüge" | translate }} {{ "(" + rechteIds.length + ")" }}
      </button>
    }
    <cap-functionbar-searchresult-buttons [listLoader]="listloader"></cap-functionbar-searchresult-buttons>
  </cap-title-functionbar>
</cap-content-header>

<cap-list-loader (currentPageEventItem)="removeAllCheckboxes()" [listLoader]="listloader">
  <div class="cap-list-loader-title">
    <ng-content select="[name=title]"></ng-content>
  </div>
  <div class="cap-list-loader-content">
    <table class="cap-table-search">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>

<ng-template #tableHeaders>
  <tr>
    <th>
      @if (listloader?.items?.length > 1) {
        <input (click)="selectAllCheckboxes(listloader?.items, $event.target)" id="selectAllCheckbox" name="cb" type="checkbox" />
      }
    </th>
    <th class="cap-10">
      <cap-column-header [columnName]="'RechteId'" [sortModel]="tableSortModel.columns.get('rechteid')"></cap-column-header>
    </th>
    <th class="cap-10">
      <cap-column-header [columnName]="'Art'" [sortModel]="tableSortModel.columns.get('art')"></cap-column-header>
    </th>
    <th class="cap-55">{{ "Beschreibung" | translate }}</th>
    <th class="cap-20">
      <cap-column-header [columnName]="'Beleg'" [sortModel]="tableSortModel.columns.get('beleg')"></cap-column-header>
    </th>
    <th class="cap-5">{{ "Auszug" | translate }}</th>
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (recht of listloader?.items; track recht; let indexOfElement = $index) {
    <tr>
      <td>
        @if (recht.art !== "PFANDRECHT" && listloader?.items?.length > 1) {
          <input
            (click)="addCheckedRecht(recht.version.id.id, $event.target)"
            [checked]="rechteIds.includes(recht.version.id.id)"
            id="inlineCheckbox2_ +{{ indexOfElement }}"
            name="cb"
            type="checkbox" />
        }
      </td>
      <td class="cap-10">
        <cap-link
          [histinfo]="recht.version.histInfo"
          [queryParams]="getQueryParams(recht)"
          [target]="navTargets.NAV_RECHT"
          [tooltipParams]="{ art: recht.art | translate }">
          {{ recht.rechteId | formatRechteId }}
        </cap-link>
      </td>
      <td class="cap-10">
        <cap-link
          [histinfo]="recht.version.histInfo"
          [queryParams]="getQueryParams(recht)"
          [target]="navTargets.NAV_RECHT"
          [tooltipParams]="{ art: recht.art | translate }">
          {{ recht.art | translate }}
        </cap-link>
      </td>
      <td class="cap-55">
        <cap-link
          [histinfo]="recht.version.histInfo"
          [queryParams]="getQueryParams(recht)"
          [target]="navTargets.NAV_RECHT"
          [tooltipParams]="{ art: recht.art | translate }">
          <cap-recht-beschreibung [item]="recht"></cap-recht-beschreibung>
        </cap-link>
      </td>
      <td class="cap-20">
        @if (recht.version.histInfo) {
          <span>
            @if (recht.version.beleg) {
              <span>
                <cap-kompakt-beleg
                  [histInfo]="recht.version.histInfo"
                  [id]="recht.version.id.id"
                  [item]="recht.version.beleg"
                  [referenzObjectId]="recht.version.id?.id"
                  [referenzObjectType]="recht.version.rechtArt"
                  beleg></cap-kompakt-beleg>
              </span>
            }
            @if (recht.version.histInfo.bisTimePoint && recht.version.histInfo.bisTimePoint.zeitpunktRechtsgueltig) {
              <span>
                @if (recht.art !== "PFANDRECHT") {
                  <br />
                }
                <cap-kompakt-timepoint
                  [item]="recht.version.histInfo.bisTimePoint"
                  loeschgeschaeft
                  placement="bottom"></cap-kompakt-timepoint>
              </span>
            }
          </span>
        }
      </td>
      <td class="cap-5">
        <cap-auszug [item]="recht"></cap-auszug>
      </td>
    </tr>
  }
</ng-template>
